import Modal from 'react-modal'
import './login-modal.css';
import agent from '../agent';
import React from 'react';
import { BACKEND_URL } from '../constants/constants';

class SGIDPromptModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoginPrompt: false,
      handle: ''
    }
  }

  openLoginPrompt = (handle) => {
    this.setState({ handle });
    this.setState({ showLoginPrompt: true });
  }
  
  closeLoginPrompt = () => {
    window.location.reload()
    this.setState({ showLoginPrompt: false });
  }

  openLoginModal = (event) => {
    if (event) event.preventDefault()
    this.closeLoginPrompt()
    let container = this.props.container
    container.openLoginModal()
  }

  render() {

    const redirectEndpoint = `${BACKEND_URL}/redirect?state=${this.state.handle}`

    return (
      <div>
        <Modal
          isOpen={this.state.showLoginPrompt}
          onRequestClose={this.closeLoginPrompt}
          className="Modal"
          overlayClassName="Overlay">
          <div className="title">Verify your identity to participate in our community!</div>
          <div className="request">
            <div>Requesting permission for:</div>
            <ul>
              <li>Name</li>
              {/* <li>Sex</li>
              <li>Nationality</li> */}
            </ul>  
          </div>
          <a className="login"
            href={redirectEndpoint}>
            Log in with SingPass
          </a>
          <div className="cancel" onClick={this.openLoginModal}>Cancel</div>
        </Modal>
      </div>
    ); 
  }
}

export default SGIDPromptModal






// WEBPACK FOOTER //
// ./src/components/SGIDPromptModal.js